import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: '¡Hola!',
  ProductCode: 'spaq42',
  Description:
    '<p>Here&#39;s all the online content included with your <strong>Spanish Exam Practice Workbook</strong>.</p>\n',
  Credits:
    '<p><em>With thanks to Encarna Aparicio-Dominguez, Lara Falomir Dominguez and Gail Partington for the proofreading.</em></p>\n' +
    '\n' +
    '<p><em>Audio produced by Voice Talent Online.</em></p>\n' +
    '\n' +
    '<p><em>AQA material is reproduced by permission of AQA.&nbsp;The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.</em></p>\n' +
    '\n' +
    '<p><em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025.&nbsp;All rights reserved.</em></p>\n',
};
